import React from "react";
import { ControlContext } from "./ControlContext";
import { useCurrentControl } from "./useCurrentControl";
export const WControlProvider = props => {
  const controlContext = useCurrentControl(props);
  const {
    status,
    errors
  } = controlContext;
  return /*#__PURE__*/React.createElement(React.Fragment, null, status && status !== "FAILURE" && /*#__PURE__*/React.createElement(ControlContext.Provider, {
    value: controlContext
  }, typeof props.children === "function" ? props.children(controlContext) : props.children), status === "FAILURE" && /*#__PURE__*/React.createElement(React.Fragment, null, JSON.stringify(errors)));
};